import { CopyButton } from "@/components/patterns/CopyButton";
import { recordCall, telHref, type CallRelation } from "./callPrompt";

/** A phone number as a `tel:` link that remembers the call, with the copy button beside it. */
export function PhoneLink({
  phone,
  relation,
}: {
  phone: string;
  relation: CallRelation;
}) {
  return (
    <span className="flex items-center gap-1">
      <a
        href={telHref(phone)}
        onClick={() => recordCall(relation)}
        className="min-w-0 break-all text-foreground underline-offset-2 hover:underline"
      >
        {phone}
      </a>
      <CopyButton value={phone} label="Telefoonnummer kopiëren" />
    </span>
  );
}
